export default __webpack_public_path__ + "static/media/bosch-logo-simple.e3622658.svg";